<template>
  <span v-html="xml"></span>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Sitemap',

  data() {
    return {
      xml: '',
      requests: '',
      items: '',
    }
  },

  created() {
  axios.get(`${process.env.VUE_APP_API}public/requests`)
  .then((data_r) => {
    data_r =  Object.keys(data_r.data.model).map(id => {
      return data_r.data.model[id].id
    })
    this.requests = data_r

    return axios.get(`${process.env.VUE_APP_API}public/items`)
    .then((data_i) => {
      data_i =  Object.keys(data_i.data.model).map(id => {
        return data_i.data.model[id].id
      })
      this.items = data_i

      this.items = this.items.reduce((array, id) => {
        const path = `https://ex.nerz.jp/item/${id}`
        array.push(path)
        return array
      }, [])

      this.requests  = this.requests.reduce((array, id) => {
        const path = `https://ex.nerz.jp/request/${id}`
        array.push(path)
        return array
      }, [])

      let routes = this.items.concat(this.requests)

      let list = routes.map(route => `<url><loc>${route}</loc></url>`)
      .join('\r\n')
      this.xml  = `<?xml version="1.0" encoding="UTF-8" ?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
      <url><loc>https://ex.nerz.jp/</loc></url>
      <url><loc>https://ex.nerz.jp/login</loc></url>
      <url><loc>https://ex.nerz.jp/privacy-policy</loc></url>
      <url><loc>https://ex.nerz.jp/terms-of-service</loc></url>
      ${list}
      </urlset>`

    }).catch((e) => {
      console.log(e)
    })

  }).catch((e) => {
    console.log(e);
  })

  }

}
</script>
